import { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';

import useUserGet from '../../hooks/useUserGet';

export const isAnalyticsEnabled = (): boolean => {
  return (
    process.env.DEPLOY_ENV === 'production' ||
    process.env.DEPLOY_ENV === 'staging' ||
    process.env.DEPLOY_ENV === 'review'
  );
};

export const useIdentifyMixpanelUser = (): void => {
  const { data: userData } = useUserGet();

  useEffect(() => {
    if (!userData?.data || !isAnalyticsEnabled()) return;
    // check to see if mixpanel has been initialized already
    try {
      mixpanel.get_distinct_id();
    } catch {
      mixpanel.init(process.env.MIXPANEL_PROJECT_TOKEN as string);
      const user = userData?.data;
      mixpanel.identify(user.id.toString());
      console.log('Mixpanel initialized');
    }
  }, [userData?.data]);
};
